//改訂日昇順でソート
export const sortByRevisionDateASC = (a: any, b: any): number => {
  if (a.revision_date < b.revision_date) {
    return -1
  } else if (a.revision_date > b.revision_date) {
    return 1
  }
  return 0
}

//改訂日降順でソート
export const sortByRevisionDateDESC = (a: any, b: any): number => {
  if (a.revision_date > b.revision_date) {
    return -1
  } else if (a.revision_date < b.revision_date) {
    return 1
  }
  return 0
}

//改訂日昇順でソート
export const sortByRevisionDateASC_2 = (a: any, b: any): number => {
  if (a.revisionDate < b.revisionDate) {
    return -1
  } else if (a.revisionDate > b.revisionDate) {
    return 1
  }
  return 0
}

//改訂日降順でソート
export const sortByRevisionDateDESC_2 = (a: any, b: any): number => {
  if (a.revisionDate > b.revisionDate) {
    return -1
  } else if (a.revisionDate < b.revisionDate) {
    return 1
  }
  return 0
}

//ドキュメント種別昇順でソート
export const sortByDocumentTypeASC = (a: any, b: any): number => {
  if (a.document_type < b.document_type) {
    return -1
  } else if (a.document_type > b.document_type) {
    return 1
  }
  return 0
}

//ドキュメント種別降順でソート
export const sortByDocumentTypeDESC = (a: any, b: any): number => {
  if (a.document_type > b.document_type) {
    return -1
  } else if (a.document_type < b.document_type) {
    return 1
  }
  return 0
}

// ドキュメント種別昇順でソート
export function sortByDocumentTypeASC_RevisonDateDESC(a: any, b: any) {
  if (a.document_type === b.document_type) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //date昇順でソートする
    if (a.document_type < b.document_type) {
      return -1
    } else if (a.document_type > b.document_type) {
      return 1
    }
  }
  return 0
}

// ドキュメント種別降順でソート
export function sortByDocumentTypeDESC_RevisonDateDESC(a: any, b: any) {
  if (a.document_type === b.document_type) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //date降順でソートする
    if (a.document_type > b.document_type) {
      return -1
    } else if (a.document_type < b.document_type) {
      return 1
    }
  }
  return 0
}

//ファイル名昇順でソート
export const sortByFileNameASC = (a: any, b: any): number => {
  if (a.file_name < b.file_name) {
    return -1
  } else if (a.file_name > b.file_name) {
    return 1
  }
  return 0
}

//ファイル名降順でソート
export const sortByFileNameDESC = (a: any, b: any): number => {
  if (a.file_name > b.file_name) {
    return -1
  } else if (a.file_name < b.file_name) {
    return 1
  }
  return 0
}

//ファイル名昇順でソート2
export const sortByFileNameASC_2 = (a: any, b: any): number => {
  if (a.fileName < b.fileName) {
    return -1
  } else if (a.fileName > b.fileName) {
    return 1
  }
  return 0
}

//ファイル名降順でソート2
export const sortByFileNameDESC_2 = (a: any, b: any): number => {
  if (a.fileName > b.fileName) {
    return -1
  } else if (a.fileName < b.fileName) {
    return 1
  }
  return 0
}

// ファイル名昇順でソート
export function sortByFileNameASC_RevisonDateDESC(a: any, b: any) {
  if (a.file_name === b.file_name) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //ファイル名昇順でソートする
    if (a.file_name < b.file_name) {
      return -1
    } else if (a.file_name > b.file_name) {
      return 1
    }
  }
  return 0
}

// ファイル名降順でソート
export function sortByFileNameDESC_RevisonDateDESC(a: any, b: any) {
  if (a.file_name === b.file_name) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //ファイル名降順でソートする
    if (a.file_name > b.file_name) {
      return -1
    } else if (a.file_name < b.file_name) {
      return 1
    }
  }
  return 0
}

//登録日昇順でソート
export const sortByRegistrationDateASC = (a: any, b: any): number => {
  if (a.registration_date < b.registration_date) {
    return -1
  } else if (a.registration_date > b.registration_date) {
    return 1
  }
  return 0
}

//登録日降順でソート
export const sortByRegistrationDateDESC = (a: any, b: any): number => {
  if (a.registration_date > b.registration_date) {
    return -1
  } else if (a.registration_date < b.registration_date) {
    return 1
  }
  return 0
}

//登録日昇順でソート
export const sortByInsertDateASC = (a: any, b: any): number => {
  if (a.insertDate < b.insertDate) {
    return -1
  } else if (a.insertDate > b.insertDate) {
    return 1
  }
  return 0
}

//登録日降順でソート
export const sortByInsertDateDESC = (a: any, b: any): number => {
  if (a.insertDate > b.insertDate) {
    return -1
  } else if (a.insertDate < b.insertDate) {
    return 1
  }
  return 0
}

//登録者昇順でソート
export const sortByInsertPersonASC = (a: any, b: any): number => {
  if (a.insertPerson < b.insertPerson) {
    return -1
  } else if (a.insertPerson > b.insertPerson) {
    return 1
  }
  return 0
}

//登録者降順でソート
export const sortByInsertPersonDESC = (a: any, b: any): number => {
  if (a.insertPerson > b.insertPerson) {
    return -1
  } else if (a.insertPerson < b.insertPerson) {
    return 1
  }
  return 0
}

// 自社商品コード昇順でソート
export function sortByOwnerProductCodeASC_RevisonDateDESC(a: any, b: any) {
  if (a.owner_product_code === b.owner_product_code) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //自社商品コード昇順でソートする
    if (a.owner_product_code < b.owner_product_code) {
      return -1
    } else if (a.owner_product_code > b.owner_product_code) {
      return 1
    }
  }
  return 0
}

// 自社商品コード降順でソート
export function sortByOwnerProductCodeDESC_RevisonDateDESC(a: any, b: any) {
  if (a.owner_product_code === b.owner_product_code) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //自社商品コード降順でソートする
    if (a.owner_product_code > b.owner_product_code) {
      return -1
    } else if (a.owner_product_code < b.owner_product_code) {
      return 1
    }
  }
  return 0
}

// 自社商品名昇順でソート
export function sortByOwnerProductNameASC_RevisonDateDESC(a: any, b: any) {
  if (a.owner_product_name === b.owner_product_name) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //自社商品名昇順でソートする
    if (a.owner_product_name < b.owner_product_name) {
      return -1
    } else if (a.owner_product_name > b.owner_product_name) {
      return 1
    }
  }
  return 0
}

// 自社商品名降順でソート
export function sortByOwnerProductNameDESC_RevisonDateDESC(a: any, b: any) {
  if (a.owner_product_name === b.owner_product_name) {
    //第二ソートキー「改訂日」の降順でソートする
    return sortByRevisionDateDESC(a, b)
  } else {
    //自社商品名降順でソートする
    if (a.owner_product_name > b.owner_product_name) {
      return -1
    } else if (a.owner_product_name < b.owner_product_name) {
      return 1
    }
  }
  return 0
}

//送信先取引先名昇順でソート
export function sortByRecipientClientNameASC(a: any, b: any) {
  if (a.recipient_client_name < b.recipient_client_name) {
    return -1
  } else if (a.recipient_client_name > b.recipient_client_name) {
    return 1
  }
  return 0
}

//送信先取引先名降順でソート
export function sortByRecipientClientNameDESC(a: any, b: any) {
  if (a.recipient_client_name > b.recipient_client_name) {
    return -1
  } else if (a.recipient_client_name < b.recipient_client_name) {
    return 1
  }
  return 0
}

//送信先取引先コード昇順でソート
export function sortByRecipientClientCodeASC(a: any, b: any) {
  if (a.recipient_client_code < b.recipient_client_code) {
    return -1
  } else if (a.recipient_client_code > b.recipient_client_code) {
    return 1
  }
  return 0
}

//送信先取引先コード降順でソート
export function sortByRecipientClientCodeDESC(a: any, b: any) {
  if (a.recipient_client_code > b.recipient_client_code) {
    return -1
  } else if (a.recipient_client_code < b.recipient_client_code) {
    return 1
  }
  return 0
}

//送信先組織昇順でソート
export function sortByRecipientDepartmentNameASC(a: any, b: any) {
  if (a.recipient_department_name < b.recipient_department_name) {
    return -1
  } else if (a.recipient_department_name > b.recipient_department_name) {
    return 1
  }
  return 0
}

//送信先組織降順でソート
export function sortByRecipientDepartmentNameDESC(a: any, b: any) {
  if (a.recipient_department_name > b.recipient_department_name) {
    return -1
  } else if (a.recipient_department_name < b.recipient_department_name) {
    return 1
  }
  return 0
}

//送信先担当者名昇順でソート
export function sortByRecipientUserNameASC(a: any, b: any) {
  if (a.recipient_user_name < b.recipient_user_name) {
    return -1
  } else if (a.recipient_user_name > b.recipient_user_name) {
    return 1
  }
  return 0
}

//送信先担当者名降順でソート
export function sortByRecipientUserNameDESC(a: any, b: any) {
  if (a.recipient_user_name > b.recipient_user_name) {
    return -1
  } else if (a.recipient_user_name < b.recipient_user_name) {
    return 1
  }
  return 0
}

//送信先担当者メールアドレス昇順でソート
export function sortByRecipientMailASC(a: any, b: any) {
  if (a.recipient_mail < b.recipient_mail) {
    return -1
  } else if (a.recipient_mail > b.recipient_mail) {
    return 1
  }
  return 0
}

//送信先担当者メールアドレス降順でソート
export function sortByRecipientMailDESC(a: any, b: any) {
  if (a.recipient_mail > b.recipient_mail) {
    return -1
  } else if (a.recipient_mail < b.recipient_mail) {
    return 1
  }
  return 0
}

//送信先フォルダ昇順でソート
export function sortByRecipientFolderNameASC(a: any, b: any) {
  if (a.recipient_folder_name < b.recipient_folder_name) {
    return -1
  } else if (a.recipient_folder_name > b.recipient_folder_name) {
    return 1
  }
  return 0
}

//送信先フォルダ降順でソート
export function sortByRecipientFolderNameDESC(a: any, b: any) {
  if (a.recipient_folder_name > b.recipient_folder_name) {
    return -1
  } else if (a.recipient_folder_name < b.recipient_folder_name) {
    return 1
  }
  return 0
}

//送信先法人番号昇順でソート
export function sortByRecipientCorporateNumberASC(a: any, b: any) {
  if (a.recipient_corporate_number < b.recipient_corporate_number) {
    return -1
  } else if (a.recipient_corporate_number > b.recipient_corporate_number) {
    return 1
  }
  return 0
}

//送信先法人番号降順でソート
export function sortByRecipientCorporateNumberDESC(a: any, b: any) {
  if (a.recipient_corporate_number > b.recipient_corporate_number) {
    return -1
  } else if (a.recipient_corporate_number < b.recipient_corporate_number) {
    return 1
  }
  return 0
}

//送信先法人名昇順でソート
export function sortByRecipientCorporateNameASC(a: any, b: any) {
  if (a.recipient_corporate_name < b.recipient_corporate_name) {
    return -1
  } else if (a.recipient_corporate_name > b.recipient_corporate_name) {
    return 1
  }
  return 0
}

//送信先法人名降順でソート
export function sortByRecipientCorporateNameDESC(a: any, b: any) {
  if (a.recipient_corporate_name > b.recipient_corporate_name) {
    return -1
  } else if (a.recipient_corporate_name < b.recipient_corporate_name) {
    return 1
  }
  return 0
}
